import styled from "styled-components";

// 각 등수별 그라데이션 배경 정의
export const RANK_BACKGROUNDS = {
  1: [
    "linear-gradient(90deg, rgba(255, 235, 105, 0.50) 0%, #FF9 50%, rgba(255, 255, 255, 0.20) 100%), #000",
    "linear-gradient(90deg, #FF9 0%, rgba(255, 235, 105, 0.50) 50%, rgba(255, 255, 255, 0.20) 100%), #000",
    "linear-gradient(90deg, #FF9 0%, rgba(255, 255, 255, 0.20) 50%, rgba(255, 235, 105, 0.50) 100%), #000",
  ],
  2: [
    "linear-gradient(90deg, rgba(237, 237, 237, 0.70) 0%, #767D82 50%, rgba(255, 255, 255, 0.20) 100%), #000",
    "linear-gradient(90deg, #767D82 0%, rgba(237, 237, 237, 0.70) 50%, rgba(255, 255, 255, 0.20) 100%), #000",
    "linear-gradient(90deg, #767D82 0%, rgba(255, 255, 255, 0.20) 50%, rgba(237, 237, 237, 0.70) 100%), #000",
  ],
  3: [
    "linear-gradient(90deg, rgba(246, 162, 63, 0.40) 0%, rgba(232, 202, 80, 0.80) 50%, rgba(255, 255, 255, 0.20) 100%), #000",
    "linear-gradient(90deg, rgba(232, 202, 80, 0.80) 0%, rgba(246, 162, 63, 0.40) 50%, rgba(255, 255, 255, 0.20) 100%), #000",
    "linear-gradient(90deg, rgba(232, 202, 80, 0.80) 0%, rgba(255, 255, 255, 0.20) 50%, rgba(246, 162, 63, 0.40) 100%), #000",
  ],
};

export const RankingBoardWrapper = styled.div`
  width: 1920px;
  height: 1080px;
  background: #101119;
  position: relative;
  background: url("/image-web/tier/ranking-board-back.png"),
    linear-gradient(rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1));
`;

export const RankingBoardNextpageButton = styled.img`
  cursor: pointer;
  position: fixed;
  bottom: 10px;
  right: 8px;
`;

export const RankingBoardBannerWrapper = styled.div`
  margin-top: 40px;
  width: 1860px;
  height: 172px;
  margin-left: 30px;
  border-radius: 12px;
  background: linear-gradient(90deg, #080b1c 33.28%, #fff 80.74%);
  position: relative;
  mix-blend-mode: lighten;
`;

export const RankingBoardBannerTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 33px;
  margin-left: 350px;
  justify-content: center;
  height: 100%;

  > .pub-name {
    color: #fff;
    font-family: Pretendard;
    font-size: 55px;
    font-style: normal;
    font-weight: 800;
    line-height: normal;
  }

  > .season-name {
    color: #fff;
    font-family: Brandy;
    font-size: 30px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`;

export const RankingBoardBannerRightImage = styled.img`
  position: absolute;
  top: 39px;
  right: 50px;
  width: 288px;
  height: 94px;
`;

export const RankingBoxWrapper = styled.div`
  width: 1860px;
  height: 800px;
  margin-top: 28px;
  margin-left: 30px;
  display: flex;
  flex-direction: row;
  gap: 21px;
`;

export const RankingBox = styled.div`
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 17px;

  > .title {
    width: 100%;
    height: 43px;
    text-align: center;
    color: #fff;
    text-align: center;
    font-family: Pretendard;
    font-size: 36px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;

    /* 타이틀 페이드 인 애니메이션 */
    animation: titleFadeIn 500ms ease-out forwards;
    opacity: 0;

    @keyframes titleFadeIn {
      0% {
        opacity: 0;
        transform: translateY(-10px) scale(0.98);
      }
      100% {
        opacity: 1;
        transform: translateY(0) scale(1);
      }
    }
  }
`;

export const RankingBoxListWrapper = styled.div`
  padding: 20px;
  padding-bottom: 12px;
  width: calc(100% - 40px);
  flex: 1;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.1);
  display: flex;
  flex-direction: column;
  gap: 14px;
  position: relative;

  > .info {
    position: absolute;
    bottom: 12px;
    left: 20px;
    color: #fff;
    font-family: Pretendard;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: -0.36px;
    white-space: pre;
  }
`;

export const RankingBoxListItemWrapper = styled.div<{
  rank: number;
  $animationDelay?: number;
}>`
  padding: 0px 30px;
  width: calc(100% - 60px);
  height: 55px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  position: relative;

  /* 페이드 인 애니메이션 */
  animation: fadeIn 500ms ease-out forwards;
  animation-delay: ${(props) => props.$animationDelay || 0}s;
  opacity: 0;

  @keyframes fadeIn {
    0% {
      opacity: 0;
      transform: scale(0.95);
    }
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }

  ${({ rank }) => {
    if (rank >= 4) {
      return `
        background: rgba(255, 255, 255, 0.15);
      `;
    }
    return "";
  }}
`;

// 각 등수별 배경 레이어 컴포넌트들
export const RankingBackgroundLayer = styled.div<{
  $opacity: number;
  $background: string;
  $isActive: boolean;
}>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 8px;
  background: ${(props) => props.$background};
  opacity: ${(props) => props.$opacity};
  transition: all 1.5s cubic-bezier(0.4, 0, 0.2, 1);
  will-change: opacity, transform, filter;
  transform: translateZ(0) scale(1);
  filter: ${(props) =>
    props.$isActive
      ? "blur(0px) brightness(1)"
      : "blur(0.3px) brightness(0.97)"};
  pointer-events: none;
  overflow: hidden;

  ${(props) =>
    props.$isActive &&
    `
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        90deg,
        transparent 0%,
        rgba(255, 255, 255, 0.15) 50%,
        transparent 100%
      );
      animation: flowingShine 1.5s ease-in-out;
      border-radius: 8px;
    }
    
    @keyframes flowingShine {
      0% {
        left: -100%;
        opacity: 0.5;
      }
      50% {
        opacity: 1;
      }
      100% {
        left: 100%;
        opacity: 0.5;
      }
    }
  `}
`;

export const RankingItemContentInfoWrapper = styled.div<{ rank: number }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;

  > .rank-text {
    width: 55px;
    height: 55px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    text-align: center;
    font-family: Pretendard;
    font-size: 23px;
    font-style: normal;
    font-weight: 800;
    line-height: normal;
    letter-spacing: 1.15px;

    > span {
      color: #fff;
      font-family: Pretendard;
      font-size: 17px;
      font-style: normal;
      font-weight: 800;
      line-height: normal;
      letter-spacing: 0.85px;
    }
  }

  > .rank {
    width: 55px;
    height: 55px;
  }

  > .name {
    color: #fff;
    font-family: Pretendard;
    font-size: 23px;
    font-style: normal;
    font-weight: 800;
    line-height: normal;

    ${({ rank }) => {
      if (rank === 1) {
        return `
          filter: drop-shadow(0 0 3px rgba(0, 0, 0, 0.70));
          background: linear-gradient(180deg, #FFF 50%, rgba(255, 255, 0, 0.00) 100%);
          background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        `;
      }
      if (rank === 2) {
        return `
          filter: drop-shadow(0 0 3px rgba(0, 0, 0, 0.70));
          background: linear-gradient(180deg, #F6F6F6 50%, rgba(135, 135, 135, 0.00) 100%);
          background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        `;
      }
      if (rank === 3) {
        return `
          filter: drop-shadow(0 0 3px rgba(0, 0, 0, 0.70));
          background: linear-gradient(180deg, #FFF 50%, rgba(255, 220, 80, 0.00) 100%);
          background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        `;
      }
    }}
  }
`;

export const RankingItemContentScoreWrapper = styled.div<{
  isGapWidth: boolean;
  rank: number;
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;

  > .score {
    min-width: ${(props) => (props.isGapWidth ? "105px" : "56px")};
    color: #fff;
    text-align: right;
    font-family: Pretendard;
    font-size: 20px;
    font-style: normal;
    font-weight: 800;
    line-height: normal;
    letter-spacing: -0.4px;

    ${({ rank }) => {
      if (rank === 1 || rank === 2 || rank === 3) {
        return `
          filter: drop-shadow(0 0 3px rgba(0, 0, 0, 0.70));
          background: linear-gradient(90deg, #FFF 0%, #FFF 100%);
          background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        `;
      }
    }}
  }

  > img {
    width: 69px;
    height: 69px;
  }
`;

export const RankingItemContent = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;
